import styled from '@emotion/styled'
import { TFunction } from 'i18next'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { toggleScheduleFeedback } from '../../actions/schedulepage'
import config from '../../config'
import { MOMENT_SHIFTLIST_DATE_FORMAT } from '../../constants'
import moment from '../../lib/moment-fi'
import { shiftListFeedback } from '../../Selectors'
import { getColor, theme } from '../../Theme'
import type { AppState, Dispatch, UserState } from '../../types'
import CalendarIllustration from '../calendar/CalendarIllustration'
import { EmphasisNormal } from '../Emphasis'
import FeedbackIcon from '../FeedbackIcon'
import { HeaderAction } from '../header/HeaderLink'
import ShiftListFeedbackWidget from '../shift/ShiftListFeedbackWidget'

const FeedbackAction = styled(HeaderAction)`
  position: absolute;
  right: ${theme.spacing.sizes.small};
`

const Title = styled(EmphasisNormal)`
  ${theme.text('normal', 'decorative', 'bold')};
  ${theme.spacing.right('biggest')};
  position: absolute;
  top: ${theme.spacing.sizes.small};
  left: ${theme.spacing.sizes.large};
  color: ${(p) => getColor(p.theme, ['black'], ['grayPink'])};
`

const Relative = styled.div`
  ${theme.layout.fluidWidth(theme.maxWidths.content)};
  position: relative;
`

type Props = {
  t: TFunction
  hasFeedback: boolean
  feedbackOpen: boolean
  listId?: string
  listStartDate: string
  listEndDate: string
  user: UserState
  onToggleFeedback: () => void
}

const CalendarShiftList = ({
  t,
  hasFeedback,
  feedbackOpen,
  listId,
  listStartDate,
  listEndDate,
  onToggleFeedback,
  user,
}: Props) => {
  return (
    <Relative>
      <CalendarIllustration startsAt={listStartDate}>
        <>
          {listId && config.features.shiftFeedback && !user.commuter_driver ? (
            <FeedbackAction
              onClick={onToggleFeedback}
              title={hasFeedback ? t('feedbackGiven') : t('yourThoughtsOnShiftList')}
            >
              <FeedbackIcon color="primaryBlue" bgColor="" notification={!hasFeedback} />
            </FeedbackAction>
          ) : undefined}
          <Title>
            {t('shiftList')} {moment(listStartDate).format(MOMENT_SHIFTLIST_DATE_FORMAT)} –{' '}
            {moment(listEndDate).format(MOMENT_SHIFTLIST_DATE_FORMAT)}
          </Title>
        </>
      </CalendarIllustration>
      {listId && feedbackOpen && config.features.shiftFeedback ? (
        <ShiftListFeedbackWidget top={24} listId={listId} onToggle={onToggleFeedback} />
      ) : undefined}
    </Relative>
  )
}

type PropsIn = {
  listId?: string
  listStartDate: string
  listEndDate: string
}

const mapStateToProps = (state: AppState, { listId }: PropsIn) => ({
  hasFeedback: !!(listId && shiftListFeedback(listId, state)?.id),
  feedbackOpen: !!(listId && state.schedulePage.feedbackOpen[listId]),
  user: state.user,
})

const mapDispatchToProps = (dispatch: Dispatch, { listId }: PropsIn) => ({
  onToggleFeedback: () => {
    if (listId) {
      dispatch(toggleScheduleFeedback(listId))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CalendarShiftList))
